import { useCallback, useEffect, useState } from "react";
import { useFetch } from "./useFetch";
import { getAuthHeaders } from "../services/auth";
import { useCachedResults } from "./useCachedResults";
export const useAutoCompleteOptions = (serverUrl,queryName,disableFetching=false)=>{
    const {isLoading,performAction} = useFetch();
    const [options,setOptions] = useState([]);
    const {getCachedResult,setCachedResult} = useCachedResults();
    const [searchKey,setSearchKey] = useState('');
    const updateSearchKey = useCallback((e)=>{
        setSearchKey(e.target.value)
    },[])
    const fetchOptions = useCallback(async(searchKey)=>{
        try{
            let identificationKey = !searchKey ? 'all': searchKey;
            const cachedResult = getCachedResult(identificationKey);
            if(cachedResult){
                return  setOptions(cachedResult);
            }
            const searchUrl = `${serverUrl}?${queryName}=${searchKey}`
            const response = await performAction(searchUrl,{method:"GET",headers:getAuthHeaders()});
            if(Array.isArray(response?.Result)){
                setCachedResult(identificationKey,response.Result);
                setOptions(response.Result);
            }
        }
        catch(e){
            console.error('Error fetching the options')
        }
    },[performAction,queryName,serverUrl,getCachedResult,setCachedResult])
    useEffect(()=>{
        if(disableFetching) return;
        const searchTimeout = setTimeout(()=>{
            fetchOptions(searchKey);
        },1500)
        return ()=>{
            clearTimeout(searchTimeout);
        }
    },[searchKey,fetchOptions,disableFetching])
    return {
        searchKey,
        updateSearchKey,
        options,
        isLoading
    }
}